// Schedule-only rows remain visible, but cannot open the portal tracker.
export const canOpenPortalJob = (job) => {
  const value = job?.ScheduleOnly ?? job?.scheduleOnly ?? job?.GeneralProjectInfo?.ScheduleOnly;
  return value == null || value === false || value === 0 ||
    (typeof value === 'string' && ['', 'false', 'no', '0'].includes(value.trim().toLowerCase()));
};
